import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { fetchBlob } from '../fetch';
import { QueryKeys } from '../keys';

export const quotationAttachmentQueryOptions = (id: number) =>
  queryOptions({
    queryKey: QueryKeys.quotations.show.attachment(id),
    queryFn: async () => {
      const attachment = await fetchBlob(`/quotations/${id}/attachment`, {
        schema: z.instanceof(Blob).or(z.null()),
      });

      return attachment;
    },
    staleTime: 60 * 1000,
    gcTime: Infinity,
  });

export const useQuotationAttachment = (id: number) => {
  return useQuery(quotationAttachmentQueryOptions(id));
};
